import * as React from 'react';
const SearchIcon = ({size}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M13.131 17.127A7.552 7.552 0 1 0 7.223 3.226a7.552 7.552 0 0 0 5.908 13.901Zm2.386-1.61 5.858 5.858"
      stroke="#071C3E"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SearchIcon;
